module.exports = __webpack_public_path__ + "24e004ab/img/mini-logo.18817ee5.svg";